import ColumnFilterContainer from '@/components/ColumnFilters/ColumnFilterContainer';
import type { ColumnFilterValue } from '@/models/flowFilter.type';
import { NumberInput } from '@mantine/core';
import { useTranslate } from '@tolgee/react';

type NumberRangeColumnFilterProps = {
  label: string;
  value: ColumnFilterValue | undefined;
  onChange: (value: ColumnFilterValue | undefined) => void;
};

const toNumber = (input: number | string): number | undefined =>
  typeof input === 'number' ? input : undefined;

/** Filtre sur une plage numérique (bornes incluses, chacune facultative). */
const NumberRangeColumnFilter = ({ label, value, onChange }: NumberRangeColumnFilterProps) => {
  const { t } = useTranslate();
  const min = value?.kind === 'number-range' ? value.min : undefined;
  const max = value?.kind === 'number-range' ? value.max : undefined;

  const update = (next: { min?: number; max?: number }) =>
    onChange(next.min == null && next.max == null ? undefined : { kind: 'number-range', ...next });

  return (
    <ColumnFilterContainer onReset={() => onChange(undefined)}>
      <NumberInput
        allowDecimal={false}
        hideControls
        label={`${label} — ${t('common.filters.min')}`}
        value={min ?? ''}
        onChange={input => update({ min: toNumber(input), max })}
      />
      <NumberInput
        allowDecimal={false}
        hideControls
        label={`${label} — ${t('common.filters.max')}`}
        value={max ?? ''}
        onChange={input => update({ min, max: toNumber(input) })}
      />
    </ColumnFilterContainer>
  );
};

export default NumberRangeColumnFilter;
